<template>
  <a class="sf-link" v-bind="$attrs">
    <slot></slot>
  </a>
</template>
<script>
export default {
  name: 'SfLink',
  data() {
    return {}
  },
}
</script>
<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.sf-link {
  font-family: $FAMILY-SANS-SERIF;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column-gap: 4px;
}
</style>
